import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  resetAppState,
  setDriverManagementExpiredModalOpen,
} from "../../../reducers/ownApp";
import {
  resetDriverManagement,
  fetchDepotMatrixWeek,
  setUserSessionExpired,
} from "../../../reducers/driverManagement/thunkActions";
import {
  getSelectedDepot,
  driverManagementExpiredModalOpenSelector,
} from "../../../reducers/ownApp/selectors";

import { Modal } from "../Modal";
import { DriverManagementExpiredContent } from "./DriverManagementExpiredContent";
import { DriverManagementExpiredActions } from "./DriverManagementExpiredActions";

export const DriverManagementExpiredModal = memo(() => {
  const dispatch = useDispatch();
  const depotCode = useSelector(getSelectedDepot);
  const open = useSelector(driverManagementExpiredModalOpenSelector);

  const onClose = () => {
    dispatch(resetDriverManagement());
    dispatch(resetAppState());
  };
  const onContinue = () => {
    dispatch(setDriverManagementExpiredModalOpen(false));
    dispatch(setUserSessionExpired(false));
    dispatch(fetchDepotMatrixWeek({ depotCode }));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={"Session Expired"}
      content={<DriverManagementExpiredContent />}
      actions={
        <DriverManagementExpiredActions
          onCancel={onClose}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
    />
  );
});
